/**
 * Partición pura de un arreglo de ids en bloques secuenciales.
 *
 * Usado por `LiquidacionesService.getExtraServiciosTabForIds` (Consolidado):
 * el backend rechaza con 400 cualquier llamada de más de 200 ids
 * (`liquidaciones-agencia-tabs.controller.ts`), así que una selección mayor a
 * 200 liquidaciones debe partirse en varias llamadas SECUENCIALES, nunca una
 * sola llamada con todos los ids.
 *
 * Ningún id se descarta acá: `chunkIds` sólo particiona, no filtra ni
 * deduplica. El tamaño por defecto (200) replica el cap real del backend —
 * si ese cap cambia, hay que actualizar los dos lados.
 */
export const EXTRA_SERVICIOS_CHUNK_SIZE = 200;

/**
 * Parte `ids` en bloques de a lo sumo `chunkSize`, preservando el orden
 * original dentro de cada bloque y entre bloques.
 *
 * `ids` vacío devuelve `[]` (cero bloques, no un bloque vacío) para que el
 * llamador pueda distinguir "nada que pedir" sin tener que inspeccionar el
 * contenido del primer bloque.
 */
export function chunkIds(
    ids: ReadonlyArray<number>,
    chunkSize: number = EXTRA_SERVICIOS_CHUNK_SIZE
): number[][] {
    if (ids.length === 0) return [];
    const chunks: number[][] = [];
    for (let i = 0; i < ids.length; i += chunkSize) {
        chunks.push(ids.slice(i, i + chunkSize));
    }
    return chunks;
}
